import { convertIRIToUuid } from '@/api/axiosHelper';
import { AdminPlaceType } from '@/enums/enums';

import { generateUUID } from './uuid';

namespace Routes {
  // ADMIN
  export const AdminLogin = () => `/login`;
  export const AdminUsersStatistics = () => `/admin/statistics/users`;
  export const AdminPlacesStatistics = (type?: AdminPlaceType) =>
    `/admin/statistics/places${type ? `?type=${type}` : ''}`;

  export const AdminPlaces = () => `/admin/places`;
  export const AdminPlace = (placeId: string) =>
    placeId ? `/admin/places/${placeId}` : Home();

  export const AdminEvents = () => `/admin/events`;
  export const AdminEvent = (eventId: string) =>
    eventId ? `/admin/events/${eventId}` : Home();

  export const AdminUsers = () => `/admin/users`;
  export const AdminUser = (userId: string) =>
    userId ? `/admin/users/${userId}` : Home();

  // Core
  export const Home = () => `/`;

  export const BuyTicket = () => `/buy-ticket`;

  export const Place = (placeId: string) =>
    placeId ? `/places/${placeId}` : Home();

  export const PlaceEvent = (placeId: string, eventId: string) =>
    `/places/${placeId}/events/${eventId}?r=${generateUUID()}`;
  export const PlaceEventTicket = (placeId: string, step: string) =>
    `/places/${placeId}/event-ticket?step=${step}`;
  export const PlaceEventTickets = (placeId: string, eventId?: string) =>
    `/places/${placeId}/event-tickets${eventId ? `?eventId=${eventId}` : ''}`;

  export const PlaceMenu = (placeId: string, serviceTable?: string) =>
    `/places/${placeId}/menu${
      serviceTable ? `?serviceTableId=${convertIRIToUuid(serviceTable)}` : ''
    }`;

  export const PlaceOrder = (placeId: string, step: string) =>
    `/places/${placeId}/order?step=${step}`;
  export const PlaceOrders = (placeId: string) => `/places/${placeId}/orders`;
}

export default Routes;
